"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1GetRecommendations = void 0;
exports.v1GetRecommendationsSetMock = v1GetRecommendationsSetMock;
exports.v1GetRecommendations = v1GetRecommendations;
exports.useQueryV1GetRecommendations = useQueryV1GetRecommendations;
exports.useInfiniteQueryV1GetRecommendations = useInfiniteQueryV1GetRecommendations;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1GetRecommendationsSetMock(mock) {
    setMock = mock;
}
async function v1GetRecommendations(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v1/user/recommendations`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.modality = params.modality;
    queryParams.workoutLengthMax = params.workoutLengthMax;
    queryParams.locale = params.locale;
    queryParams.fitnessGoals = params.fitnessGoals;
    queryParams.improvePerformance = params.improvePerformance;
    queryParams.loseWeight = params.loseWeight;
    queryParams.healthWellness = params.healthWellness;
    queryParams.workoutTypes = params.workoutTypes;
    queryParams.eventTraining = params.eventTraining;
    queryParams.softwareNumber = params.softwareNumber;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1GetRecommendations = 'cockatoo:v1GetRecommendations:get';
function useQueryV1GetRecommendations(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetRecommendations, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1GetRecommendations(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetRecommendations, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1GetRecommendations(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-get-recommendations.js.map